import* as d3 from 'd3';

import { ResultsStatus } from '../../models';

export const symbolsScale = d3.scale.ordinal<ResultsStatus, string>()
    .domain([ResultsStatus.Ok, ResultsStatus.Warning, ResultsStatus.Error, ResultsStatus.Unknown])
    .range(['circle', 'triangle-up', 'cross', 'circle']);